module.exports = __webpack_public_path__ + "static/media/menu list.1f14f053.png";